import { createSlice } from '@reduxjs/toolkit';
import { isBefore } from 'date-fns';
import jwtDecode from 'jwt-decode';
import { AdminUserState } from "../interfaces";
import api from "../../services/api";
import { getCurrentAuth, getSafeLocale, isValidObject } from "../../utils";

let token = '';
let admin = {
    _id: '',
    first_name: '',
    last_name: '',
    email: '',
    locale: '',
    role: ''
}

const currentAuth = getCurrentAuth();
if (
    isValidObject(currentAuth) &&
    currentAuth.expires &&
    currentAuth.access_token &&
    isBefore(new Date(), new Date(currentAuth.expires))
) {
    token = currentAuth.access_token;
    api.defaults.headers.authorization = token;
    const decodedToken: any = jwtDecode(currentAuth.access_token);
    admin = {
        _id: decodedToken._id,
        first_name: decodedToken.first_name,
        last_name: decodedToken.last_name,
        email: decodedToken.email,
        role: decodedToken.role,
        locale: getSafeLocale(decodedToken.locale)
    }
}

const initialState: AdminUserState = {
    isAuthenticated: !!token,
    ...admin,
};
export const adminUserSlice = createSlice({
    name: 'adminUser',
    initialState,
    reducers: {
        increment: (state) => {
            state._id = "1"
        },
        logout: (state) => {
            state.isAuthenticated = false
        },
    },
});
export default adminUserSlice.reducer;
